// extracted by mini-css-extract-plugin
module.exports = {"core":"header-module--core--1WeMj","title":"header-module--title--c95nu","action":"header-module--action--3eghL","text":"header-module--text--35xQz"};